"use client";

import React, { useState } from "react";
import DentalTopBar from "@/components/demos/dental/DentalTopBar";

export default function DentalDemoClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [currency, setCurrency] = useState<"INR" | "USD">("INR");

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col font-sans">
      <DentalTopBar currency={currency} onCurrencyChange={setCurrency} />
      <main className="flex-1">
        {React.isValidElement(children)
          ? React.cloneElement(children as React.ReactElement<any>, { currency })
          : children}
      </main>
    </div>
  );
}
